<script setup lang="ts">
import { inject, ref } from 'vue'
import { useToast as usePrimeToast } from 'primevue/usetoast'
import { updateUserEmail } from '~/layers/cms/app/composables/cms'

const toast = usePrimeToast()
const dialogRef = inject<DialogRef>('dialogRef')
const newEmail = ref<string>('')

interface DialogRef {
  value: {
    data: {
      choosenUserId: number
    }
    close(): void
  }
}

const closeDialog = () => {
  if (!dialogRef) return
  dialogRef.value.close()
}

const updateEmail = async () => {
  if (!dialogRef || !dialogRef.value.data.choosenUserId || !newEmail.value) return
  const response = await updateUserEmail(dialogRef.value.data.choosenUserId, newEmail.value)
  if (!response.status_ok) {
    toast.add({
      severity: 'error',
      summary: 'Error',
      detail: 'Nie udało się zaaktualiować emaila usera',
      life: 3000
    })
  } else {
    toast.add({
      severity: 'info',
      summary: 'Info',
      detail: 'Poprawnie zaaktualizowano email usera',
      life: 3000
    })
    closeDialog()
  }
}
</script>

<template>
  <div class="flex flex-col gap-4">
    <label>
      Wpisz nowy email:
      <InputText
        v-model="newEmail"
        type="email"
        required
      />
    </label>
    <Button
      type="button"
      label="Zapisz"
      severity="primary"
      @click="updateEmail"
    />
  </div>
</template>
